module.exports = __webpack_public_path__ + "img/lens-174-minus-09.02d78a28.png";